import classNames from "classnames";

import { ChevronDown } from "@/shared/foundation/icons";

import styles from "./FloatingScrollButton.module.css";

interface ScrollToBottomButtonProps {
  /** Whether to show the button */
  show: boolean;

  /** Callback when button is clicked */
  onClick: () => void;

  /** Whether a reply is streaming in; rings the button with a pulsing glow. */
  loading: boolean;
}

/**
 * A floating button that appears when the user has scrolled up
 * from the bottom of content. Clicking it scrolls back to the bottom.
 */
export function ScrollToBottomButton({
  show,
  onClick,
  loading,
}: ScrollToBottomButtonProps) {
  if (!show) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(styles.button, {
        [styles.generating]: loading,
      })}
    >
      <ChevronDown className={styles.icon} aria-hidden />
      Scroll to bottom
    </button>
  );
}
